$(function(){
	
  /**************/
  /* Header Nav */
  /**************/
  
  // Nav - PC
  $('#nav-menu-pc .part3 .part3-inner td p a').hover(function(){
    
    $('.overlay').css('display', 'block');
    
    $(this).parent().parent().css('border-bottom', '2px solid #000000');

    var main_menu_cat = $(this).attr('class').replace('main-menu-cat-', '');
    $('.main-menu-links-ctn').each(function(){
      if( $(this).attr('class').includes('main-menu-links-' + main_menu_cat) ) {
        $(this).fadeIn();
      } else {
        $(this).hide();
      }
    });
  });

  $('#nav-menu-pc .part3 .part3-inner td p a').mouseleave(function(){
    $(this).parent().parent().css('border-bottom', 'none');
  });

  $('.overlay').mouseenter(function(){
    $('.main-menu-links-ctn').hide();
    $('.overlay').css('display', 'none');
  });
  
  $('#nav-menu-pc .part2').mouseenter(function(){
    $('.main-menu-links-ctn').hide();
    $('.overlay').css('display', 'none');
  });

  // Nav - Mobile
  $('#nav-menu-mb .part2 img[alt="hamburger"]').click(function() {
    var isVisible = $('#nav-menu-mb .part3').css('display');
    if( isVisible == 'none' ) {
      $('#nav-menu-mb .part3').show();
      $('#nav-menu-mb .part2 img[alt="hamburger"]').attr('src', 'https://cdn.shopify.com/s/files/1/0013/7337/2467/files/icons8-close-thick.png?v=1646732541');
    
      $('.overlay-mb').css('display', 'block');
    } else {
      $('#nav-menu-mb .part3').hide();
      $('#nav-menu-mb .part2 img[alt="hamburger"]').attr('src', 'https://cdn.shopify.com/s/files/1/0013/7337/2467/files/icon-hamburger.png?v=1646732531');
      
      $('.overlay-mb').css('display', 'none');

      $('#nav-menu-mb .part3 .mb-menu-links').hide();
      $('#nav-menu-mb .part3 .mb-menu-cat img.showmore').attr('src', 'https://cdn.shopify.com/s/files/1/0013/7337/2467/files/footer-links-down.png?v=1646367791');
    }

    $('.overlay-mb').click(function(){
      $('#nav-menu-mb .part3').hide();
      $('#nav-menu-mb .part2 img[alt="hamburger"]').attr('src', 'https://cdn.shopify.com/s/files/1/0013/7337/2467/files/icon-hamburger.png?v=1646732531');
      $('.overlay-mb').css('display', 'none');
      $('#nav-menu-mb .part3 .mb-menu-links').hide();
      $('#nav-menu-mb .part3 .mb-menu-cat img.showmore').attr('src', 'https://cdn.shopify.com/s/files/1/0013/7337/2467/files/footer-links-down.png?v=1646367791');
    });

  });

  $('#nav-menu-mb .part3 .mb-menu-cat img.showmore').click(function(){
    var menu_cat = $(this).attr('class').replace('showmore showmore-', '');
    // alert(menu_cat);
    var isVisible = $('#nav-menu-mb .part3 .mb-menu-links.mb-menu-links-' + menu_cat).css('display');
    if( isVisible == 'none' ) {
      $('#nav-menu-mb .part3 .mb-menu-links.mb-menu-links-' + menu_cat).slideDown();
      $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0013/7337/2467/files/footer-links-up.png?v=1646367791');
    } else {
      $('#nav-menu-mb .part3 .mb-menu-links.mb-menu-links-' + menu_cat).slideUp();
      $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0013/7337/2467/files/footer-links-down.png?v=1646367791');
    }
  });

  $('#nav-menu-mb .part2 img[alt="search"]').click(function(){
    var isVisible = $('#nav-menu-mb .part4').css('display');
    if( isVisible == 'none' ) {
      $('#nav-menu-mb .part4').slideDown();
    } else {
      $('#nav-menu-mb .part4').slideUp();
    }
  });
  
  
  /**********/
  /* Footer */
  /**********/
  
  $('#main-footer2 .subscribe-ctn form').submit(function() {
  	alert('Your email has been successfully subscribed.');
  });
  
  $('#main-footer2-mb .subscribe-ctn form').submit(function() {
  	alert('Your email has been successfully subscribed.');
  });


  /* Add-to-cart Notification */
  $('#AddToCart-product-template-new').click(function(){
    setTimeout(function(){ 
      $.getJSON('/cart.js', function (cart, textStatus) {
        var cart_item_0 = parseInt( $('#victor_cart_item_count').val() );
        var cart_item_1 = cart.item_count;
        if( cart_item_0 < cart_item_1 ){
          $('#nav-menu-pc a.site-header__cart .site-header__cart-indicator').removeClass('hide');
          $('#nav-menu-mb a.site-header__cart .site-header__cart-indicator').removeClass('hide');
          $('#NotificationSuccess').css({'visibility': 'visible', 'opacity': '1'});
          setTimeout(function(){
             $('#NotificationSuccess button.notification__close').click();
          }, 3000);
        }
        
      });
    }, 500);
  });

  $('#NotificationSuccess button.notification__close').click(function(){
    $('#NotificationSuccess').css({'visibility': 'hidden', 'opacity': '0'});
  });
  
  
});

